export const SESSION_NAME = 'smp_mmb_' + ( import.meta.env.NODE_ENV !== 'production' ? '_dev' : '')
export const SHOW_PRICE = 'ui_show_price'
export const NOTIF_PIUTANG = 'ui_notif_piutang'
export const MODE = import.meta.env.NODE_ENV
export const ASSET_URL = import.meta.env.VITE_ASSET_URL
export const TIPE_ITEM = [{id: "INV",label: "[INV] Barang"},{id: "SRV",label: "[SRV] Jasa"},{id: "ASM",label: "[ASM] Rakitan"},{id: "NON-INV",label: "[NON-INV] Non Inventory"}]
export const TAX_OPTIONS = [{id:"non", label:"Non PPN"}, {id:"exclude", label:"PPN Exclude"}, {id:"include", label:"PPN Include"}]
export const PAYMENT_OPTIONS = [{id:"TRANSFER", label:"BAYAR DULU"},{id:"DEPOSIT", label:"DEPOSITO"},{id:"KREDIT", label:"LIMIT PIUTANG"}]
export const GOOGLE_LOGIN =  {
    clientId: '93547890176-rpp6v8vu3t99bt4hn5ot0efvcdhmgucr.apps.googleusercontent.com',
    clientSecret: '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'
}